import type {WorkflowStatus} from '../../types/filmWorkflow';
/** B4: chấm cấu trúc đã lưu sau chặng 1; không tự mua lại kết quả UNKNOWN hoặc chạy lại GEN_PLAN.
 * 261029: CHỈ tự chạy khi phiếu SCRIPT là `NOT_REVIEWED`. Phiếu `STALE` (người sửa sau đó, vd đổi giây) KHÔNG tự chạy — máy tự sửa sẽ viết lại Phân đoạn thật; người bấm chấm lại ở thẻ chất lượng. */
export function scriptQualityContinuation(status:WorkflowStatus|null):string|null{
 const stage=status?.workflowRuns?.stage1,signal=status?.qualityByStep?.SCRIPT,run=status?.stepRuns?.SCRIPT;
 if(!stage||stage.status!=='COMPLETED'||status?.qualityByStepUnavailable||status?.jobs.length||run?.canStop)return null;
 // Plan workflowGeneration cũ chưa có marker sẽ opt-in khi POST SCRIPT; GET vẫn không backfill.
 if(!signal&&status?.stepCapabilities?.SCRIPT?.canRun!==true)return null;
 if(signal&&signal.state!=='NOT_REVIEWED')return null;
 if(run){
  const afterStage=stage.endedAt?Date.parse(stage.endedAt):NaN,started=run.createdAt?Date.parse(run.createdAt):NaN;
  if(!Number.isFinite(afterStage)||!Number.isFinite(started)||started>=afterStage)return null;
 }
 return stage.jobId;
}
